export const EMAIL_CONFIG = {
  SERVICE_ID: 'service_j8d6tdi',
  TEMPLATE_ID: 'template_ggh02tf',
  PUBLIC_KEY: 'QjlbsOR9mI133br2R',
  RECIPIENT_EMAIL: 'danbones33@gmail.com'
} as const;